import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { RUM_CONFIG } from './rum.config';

/**
 * Stores the user's telemetry-cookie decision. No cookie banner exists in the
 * repo yet; once one does, call grant()/revoke() from it.
 */
@Injectable({ providedIn: 'root' })
export class TelemetryConsentService {
  private readonly state = signal<boolean>(this.read());
  readonly changes$ = new Subject<boolean>();

  get granted(): boolean {
    return this.state();
  }

  grant(): void {
    this.set(true);
  }

  revoke(): void {
    this.set(false);
  }

  private set(granted: boolean): void {
    this.state.set(granted);
    try {
      localStorage.setItem(RUM_CONFIG.consentStorageKey, granted ? 'granted' : 'denied');
    } catch {
      // storage unavailable: keep in-memory decision only
    }
    this.changes$.next(granted);
  }

  private read(): boolean {
    try {
      return localStorage.getItem(RUM_CONFIG.consentStorageKey) === 'granted';
    } catch {
      return false;
    }
  }
}
